import * as React from 'react';
import {useRef} from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import {numberFormat} from "../helpers";
import {Grid, LinearProgress, Stack} from "@mui/material";
import Typography from "@mui/material/Typography";
import {utils, writeFileXLSX} from "xlsx";
import ModalPage from "./ModalPage";
import Paper from "@mui/material/Paper";

const minWidth = (width) => {
    switch (width) {
        case "x-small":
            return 25;
        case "small":
            return 50;
        case "medium":
            return 100;
        case "larger":
            return 150;
        case "x-larger":
            return 250;
    }
    return 200;
}

export default function TableView(props) {
    const modal = useRef();

    const handleChangePage = (event, newPage) => {
        props.setPage(newPage);
    };
    const handleChangeRowsPerPage = (event) => {
        props.setPerPage(+event.target.value);
        props.setPage(1);
    };

    const createData = (row) => {
        let arr = props.columns;
        let obj = {};
        for (let i = 0; i < arr.length; i++) {
            const value = row[arr[i].id];
            obj[arr[i].label] = arr[i].format && typeof value === 'number' ? numberFormat(arr[i].format(value)) : value;
        }
        return obj;
    }
    const generateExportData = () => {
        return props.rows.data.map((row) => createData(row));
    }

    const downloadExcel = () => {
        const wb = utils.book_new();
        utils.book_append_sheet(wb, utils.json_to_sheet(generateExportData()));
        writeFileXLSX(wb, "document.xlsx");
    }

    return (
        <>
            <Stack>
                <Grid container spacing={1} sx={{p: 1}}>
                    <Grid item xs={12}>
                        <Typography variant="h5">{props.title}</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        {props.showProgres && <LinearProgress/>}
                    </Grid>
                </Grid>
                <Paper sx={{width: '100%', overflow: 'auto'}}>
                    <TableContainer sx={{maxHeight: 550}}>
                        <Table stickyHeader aria-label="sticky table" size="small" sx={{
                            "& .MuiTableCell-root": {
                                border: '1px solid #e8e8e8'
                            },
                            "& .css-17syrjq-MuiTableCell-root": {
                                zIndex: "0 !important"
                            }
                        }}>
                            <TableHead>
                                <TableRow>
                                    <TableCell
                                        key="id"
                                        style={{minWidth: 50}}
                                        sx={{background: "#eeeeee !important", fontWeight: "bold"}}
                                    >
                                        SN
                                    </TableCell>
                                    {props.columns.map((column) => (
                                        <TableCell
                                            key={column.id}
                                            align={column.align}
                                            style={{minWidth: minWidth(column?.minWidth || 100)}}
                                            sx={{background: "#eeeeee !important", fontWeight: "bold"}}
                                        >
                                            {column.label}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {props.rows.data
                                    .map((row, index) => {
                                        return (
                                            <TableRow hover={true} tabIndex={-1} key={index}>
                                                <TableCell key="id">
                                                    {index + 1}
                                                </TableCell>
                                                {props.columns.map((column) => {
                                                    const value = column?.customerRender ? column.valueGetter(row) : row[column.id];
                                                    return (
                                                        <TableCell key={column.id} align={column.align} onClick={() => {
                                                            if (!column?.disabled && props?.rowClick) {
                                                                props.rowFunction(row);
                                                            }
                                                        }}>
                                                            {column.format && typeof value === 'number'
                                                                ? numberFormat(column.format(value))
                                                                : value}
                                                        </TableCell>
                                                    );
                                                })}
                                            </TableRow>
                                        );
                                    })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <TablePagination
                        rowsPerPageOptions={[10, 25, 100]}
                        component="div"
                        count={props.rows.total}
                        rowsPerPage={props.perPage}
                        page={props.rows.total > 0 ? props.page : 0}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </Paper>
            </Stack>
            <ModalPage ref={modal}/>
        </>
    )
        ;
}